import { render, staticRenderFns } from "./FileThumbnail.vue?vue&type=template&id=fcd726cc"
import script from "./FileThumbnail.vue?vue&type=script&lang=js"
export * from "./FileThumbnail.vue?vue&type=script&lang=js"
import style0 from "./FileThumbnail.vue?vue&type=style&index=0&id=fcd726cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports